
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Axios from "axios";

export default function DanhSachCongViec() {
  const { user } = useSelector((state) => state.auth);
  const [params, setParam] = useState();
  const [listFinderId, setListFinderId] = useState('');
  const [keyword, setKeyword] = useState('');
  const [filterShow, setFilterShow] = useState(false)
  const [showJob, setShowJob] = useState(false)

  const [teamJobs, setTeamJobs] = useState([])
  const [btnActive, setBtnActive] = useState(0)


  const handleSubmit = (e) => {
    e.preventDefault();
    let _param = ''
    if (keyword !== '') _param += "&title=" + keyword
    if (listFinderId !== '') _param += "&id=" + listFinderId
    setParam(_param);
  };
  let columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    {
      name: "title", label: "Nội dung công việc",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div className="w-100">
            <strong>{value}</strong><br />
            <i>{tableMeta.description}</i>
          </div>
        }
      }
    },
    {
      name: "kanban", label: "Tiến độ",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            return value.map((item) => {
              return <div className="btn btn-sm mr-2 mb-2 pr-5 position-relative" key={item.id} style={{ borderTop: `4px solid ${item.color}`, backgroundColor: '#f8f9fa' }}>
                <span>{item.title}</span>
                <span className="number d-flex justify-content-center align-items-center position-absolute" style={{ top: 5, right: 5, zIndex: 9, borderRadius: "100%", width: 20, height: 20, backgroundColor: item.color, fontSize: 11 }}>
                  {item.counter}
                </span>
              </div>
            })
          } else {
            return ""
          }
        },
      }
    },
    { name: "author_name", label: "Người tạo" },
    { name: "datecreate", label: "Ngày tạo" }
  ];

  useEffect(
    function () {
      Axios.get(URL_LIST_ALL + "congvieccuatoi", user.config).then(async (res) => {
        if (res.data.status === "success") {
          setTeamJobs(res.data.data)
        } else console.log(res.data.message);
      }).catch((err) => console.log(err));
    }, [user]
  );


  return (<AkkhorLayout idrole="works_order">
    <div className="breadcrumbs-area">
      <ul>
        <li>
          <Link to="/">Trang chủ</Link>
        </li>

        <li>Danh sách Công việc</li>
      </ul>
    </div>
    <div className="card mb-3">
      <div className="card-header">
        <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
          <div className="mr-auto">
            <h5 className="title">Tìm kiếm</h5>
          </div>
          <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
        </div>
      </div>
      <div className={filterShow ? "card-body" : 'hidden-filter'}>
        <form className="new-added-form" method="get" >
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
              <label>Từ khoá </label>
              <input type="text" placeholder="Tìm theo từ khoá" value={keyword} onChange={(e) => setKeyword(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-12 ">
              <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div className="card mb-3">
      <div className="card-header">
        <div className="d-flex" onClick={() => setShowJob(!showJob)}>
          <div className="mr-auto">
            <h5 className="title">Báo cáo công việc</h5>
          </div>
          <button className="btn btn-sm btn-defaul"><span className={!showJob ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
        </div>
      </div>
      <div className={showJob ? "card-body" : 'hidden-filter'}>
        <div className="w-100">
          {teamJobs && teamJobs.map(item => {
            return <div className="card mb-2" key={"j" + item.key}>
              <div className="card-body p-2">
                <div className="d-flex align-items-center justify-content-between">
                  <strong>{item.fullname}</strong>
                  <div className="d-flex">
                    {(item.data && item.data.length > 0) && item.data.map(job => {
                      return <div className="ml-2" key={job.id}>
                        <button type="button" className="btn btn-sm" style={{ border: `2px solid ${job.color}`, backgroundColor: (btnActive == (item.user_id +'-'+ job.id) ? job.color : 'transparent'), color: (btnActive == (item.user_id +'-'+ job.id) ? '#FFF' : job.color) }}
                          onClick={() => {
                            if (job.counter > 0) {
                              setParam("&list_id=" + job.list_work_id)
                              setBtnActive(item.user_id +'-'+ job.id)
                            }
                          }}>
                          {job.title}: {job.counter}
                        </button>
                      </div>
                    })}
                  </div>
                </div>
              </div>
            </div>
          })}
        </div>
      </div>
    </div>


    <SRList name="works_order" linkaction="works_order" idrole="works_order" params={params} title="Nghiệp vụ" defaultLimit={50} serverSide={true} columns={columns}>

    </SRList>
  </AkkhorLayout>);
}
